import { render, staticRenderFns } from "./IssueForm.vue?vue&type=template&id=9f800272&"
import script from "./IssueForm.vue?vue&type=script&lang=ts&"
export * from "./IssueForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports